// Chemin : src/components/clientadmin/pages/ClientModulesManager.js

const clientModules = [
  {
    path: "dashboard",
    label: "Tableau de bord",
    icon: "home"
  },
  {
    path: "utilisateurs",
    label: "Utilisateurs",
    icon: "users",
    children: [
      {
        path: "nouveau",
        label: "Créer un utilisateur",
        icon: "user-plus"
      }
    ]
  },
  {
    path: "dossiers",
    label: "Dossiers",
    icon: "folder",
    children: [
      {
        path: "nouveau",
        label: "Créer un dossier",
        icon: "folder-plus"
      },
      {
        path: "retards",
        label: "Dossiers en retard",
        icon: "alert-triangle"
      },
      {
        path: "clotures",
        label: "Dossiers clôturés",
        icon: "check-circle"
      }
    ]
  },
  {
    path: "notifications",
    label: "Notifications",
    icon: "bell"
  },
  {
    path: "documents",
    label: "Documents",
    icon: "file"
  },
  {
    path: "parametres",
    label: "Paramètres",
    icon: "settings"
  }
];

export default clientModules;
